module.exports = __webpack_public_path__ + "img/error-hint.13041c36.svg";